import React, { useState, useCallback } from 'react';
import _ from 'lodash';

const Context = React.createContext();

export const BreadcrumbProvider = ({ children }) => {
    const [crumbs, setCrumbs] = useState([]);

    const addCrumb = useCallback((crumb) => {
        const matched = crumbs.find(b => {
            return crumb.key === b.key;
        });

        if (_.isEmpty(matched)) {
            setCrumbs((crumbs) => ([...crumbs, crumb]));
        }
    }, [crumbs]);

    const removeCrumb = useCallback((key) => {
        setCrumbs((crumbs) => crumbs.filter((crumb) => key !== crumb.key), [setCrumbs]);
    }, [setCrumbs]);

    const value = { crumbs, addCrumb, removeCrumb };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useBreadcrumbStore = () => React.useContext(Context);
